/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Agent_Schedule_Summary_WeekdaysInputs */



/**
* | output |
* | --- |
* | "Every weekday at {time}" |
*
* @param {Agent_Schedule_Summary_WeekdaysInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_schedule_summary_weekdays = /** @type {((inputs: Agent_Schedule_Summary_WeekdaysInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Schedule_Summary_WeekdaysInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Werktags um ${i?.time}`)
	return /** @type {LocalizedString} */ (`Every weekday at ${i?.time}`)
});